<template>
    <div style="height: 38px" class="hover-item">
        <div class="d-flex fill-height">
            <div style="width: 10%" class=" fill-height py-1 px-2 t-b text-caption">{{row.farm.description}}</div>
            <div style="width: 28%" class=" fill-height py-1 px-2 t-b text-caption">{{row.emp.fullName}}</div>
            <div style="width: 8%" class=" fill-height py-1 px-2 t-b text-caption">{{row.emp.empCode}}</div>
            <div style="width: 10%" class=" fill-height py-1 px-2 t-b text-caption">{{row.clockInStr}}</div>
            <div style="width: 10%" class=" fill-height py-1 px-2 t-b text-caption">{{row.lastActionStr}}</div>
            <div style="width: 8%" class=" fill-height py-1 px-2 t-b text-caption text-end">{{row.binUnits}}</div>
            <div style="width: 10%" class=" fill-height py-1 px-2 t-b text-caption">{{row.pieceWorkStr}}</div>
            <div style="width: 8%" class=" fill-height py-1 px-2 t-b text-caption text-end">{{row.pieceWorkUnits}}</div>
            <div style="width: 8%" class=" fill-height py-1 px-2 t-b text-caption text-end">{{row.hours}}</div>
        </div>
    </div>
<!--    <tr>-->
<!--        <td class=" pa-2 text-caption">{{row.farm.description}}</td>-->
<!--        <td class=" pa-2 text-caption">{{row.emp.fullName}}</td>-->
<!--        <td class=" pa-2 text-caption">{{row.emp.empCode}}</td>-->
<!--        <td class=" pa-2 text-caption">{{row.clockInStr}}</td>-->
<!--        <td class=" pa-2 text-caption">{{row.lastActionStr}}</td>-->
<!--        <td class=" pa-2 text-caption text-end">{{row.binUnits}}</td>-->
<!--        <td class=" pa-2 text-caption">{{row.pieceWorkStr}}</td>-->
<!--        <td class=" pa-2 text-caption text-end">{{row.pieceWorkUnits}}</td>-->
<!--        <td class="pa-2 text-caption text-end">{{row.hours}}</td>-->
<!--    </tr>-->
</template>

<script>
export default {
    props: {
        row: Object
    }
}
</script>

<style scoped>
.hover-item:hover{
    background-color: rgba(0,0,0,0.03);
}
</style>